// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ICheckWritingTypeDto
 */
export interface ICheckWritingTypeDto {
    /**
     * 
     * @type {number}
     * @memberof ICheckWritingTypeDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ICheckWritingTypeDto
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof ICheckWritingTypeDto
     */
    description?: string;
}

/**
 * Check if a given object implements the ICheckWritingTypeDto interface.
 */
export function instanceOfICheckWritingTypeDto(value: object): value is ICheckWritingTypeDto {
    return true;
}

export function ICheckWritingTypeDtoFromJSON(json: any): ICheckWritingTypeDto {
    return ICheckWritingTypeDtoFromJSONTyped(json, false);
}

export function ICheckWritingTypeDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ICheckWritingTypeDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'description': json['description'] == null ? undefined : json['description'],
    };
}

export function ICheckWritingTypeDtoToJSON(json: any): ICheckWritingTypeDto {
    return ICheckWritingTypeDtoToJSONTyped(json, false);
}

export function ICheckWritingTypeDtoToJSONTyped(value?: ICheckWritingTypeDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'description': value['description'],
    };
}

